import { getLanguage } from '../services/APIAgent';

let dictionary = null;
let loaded = false;

export function loadLanguage(baseLangauge) {
    return getLanguage(baseLangauge)
    .then(({ dictionary: d }) => {
        dictionary = d;
        loaded = true;
    });
};

export function localise(key) {
    if (!loaded) throw new Error('Not loaded');
    if (!dictionary[key]) console.log(`"${key}" not found.`);

    return dictionary[key] || key;
}


// WEBPACK FOOTER //
// ./src/services/Language.js